import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { PAGE_SUB_TYPE, PAGE_TYPE } from 'constants/footPrintTracking';
import { FootPrintTracking } from 'components/Globals/FootPrintTracking/FootPrintTracking';
import { withTranslation, Router } from '../../src/i18n';
import CompaniesSearchForm, { companiesSearchFields } from '../../components/CompaniesSearchForm';
import CountriesList from '../../components/CountriesList';
import ListingPageLayout from '../../components/ListingPageLayout';
import route from '../../constants/routes';

import {
  selectCompaniesCountries,
  selectCompaniesCountriesOptions,
  selectCompanies,
} from '../../containers/Companies/selectors';
import { getCompaniesCountriesAction } from '../../containers/Companies/actions';
import { removeWithTranslationProps } from '../../utils/common';
import { useFormFilters, getFlatFormValues } from '../../utils/formUtils';
import { TP } from '../../constants/consts';
import { getWholeList } from '../../containers/App/actions';
import { FILTER_AGGREGATION_SEARCH, COMPANIES } from '../../constants/endpointConstants';
import getInjectors from '../../store/reducerInjectors';
import reducer, { key } from '../../containers/Companies/reducer';
import { useInjectReducer } from '../../store/injectReducer';

const CompaniesPage = ({ t, countries, countriesOptions, companiesList, searchQuery }) => {
  useInjectReducer([{ key, reducer }]);
  const [formValues] = useFormFilters(companiesSearchFields, searchQuery, get(companiesList, 'filters'));

  const searchFiltersComponent = (
    <CompaniesSearchForm
      showFilter={false}
      countries={countriesOptions}
      submitFunc={values =>
        Router.push({
          pathname: `${route.COMPANIES}/search`,
          query: getFlatFormValues(values),
        })
      }
      initialValues={formValues}
    />
  );

  const customBreadcrumbs = [
    { path: route.HOME, title: `${TP}.m_HOME` },
    { path: `${route.COMPANIES}/`, title: `${TP}.m_OPCOS` },
  ];

  const contentCountries = (
    <CountriesList
      countries={countries ? countries.data : []}
      path={`${route.COMPANIES}/[country]`}
      as={`${route.COMPANIES}`}
    />
  );

  const trackingData = {
    pageType: PAGE_TYPE.LISTING_PAGE,
    pageSubType: PAGE_SUB_TYPE.ORGANISATION,
  };

  return (
    <FootPrintTracking data={trackingData}>
      <ListingPageLayout
        title={t(`${TP}.m_OPCOS`)}
        seo={{
          title: t('operabase.general.SEO_TITLE_COMPANIES_INDEX'),
          description: t('operabase.general.SEO_DESC_COMPANIES_INDEX'),
          ogTitle: t('operabase.general.SEO_OG_TITLE_COMPANIES_INDEX'),
        }}
        customBreadcrumbs={customBreadcrumbs}
        subTitle={t(`${TP}.FN_FINDCOMPANIESBYCOUNTRY`)}
        searchFiltersComponent={searchFiltersComponent}
        content={contentCountries}
        contentDivider={false}
      />
    </FootPrintTracking>
  );
};

CompaniesPage.propTypes = {
  t: PropTypes.func.isRequired,
  countries: PropTypes.object,
  countriesOptions: PropTypes.array,
  companiesList: PropTypes.object,
};

const mapStateToProps = createStructuredSelector({
  countries: selectCompaniesCountries(),
  countriesOptions: selectCompaniesCountriesOptions(),
  companiesList: selectCompanies(),
});

const withConnect = connect(mapStateToProps, null);

CompaniesPage.getInitialProps = async ctx => {
  const { store, query } = ctx;
  getInjectors(store).injectReducer([{ key, reducer }]);
  const countriesList = get(store.getState().Companies, 'companiesCountries.data', []);
  const strippedQuery = removeWithTranslationProps(query);
  if (countriesList.length === 0) {
    store.dispatch(
      getWholeList({
        endpoint: FILTER_AGGREGATION_SEARCH(COMPANIES),
        sagaRoutine: getCompaniesCountriesAction,
        params: { queryParams: { aggregation_type: 'country_id', sort: 'name', has_productions: 'yes' } },
      }),
    );
  }

  return {
    namespacesRequired: ['translation', 'edit'],
    searchQuery: strippedQuery,
  };
};

export default compose(withTranslation('translation'), withConnect)(CompaniesPage);
